import fetch from 'isomorphic-fetch';

export const getGalleryImages = (baseUrl, siteId, id, itemType) => {
  return fetch(`${baseUrl}/api/get-gallery?siteId=${siteId}&id=${id}&itemType=${itemType}`).then(
    (response) => {
      if (response.status >= 400) {
        throw new Error(
          `Bad response from server while fetching gallery images for id:${id} and itemType${itemType}:, on siteId:${siteId}`,
        );
      }
      return response.json();
    },
  );
};
